export var getPageMetaData = function getPageMetaData(state) {
  return state.page.metaData;
};
export var getUrls = function getUrls(state) {
  return state.page.urls;
};